import * as React from 'react';
import AlarmTemplateConfig from './alarmTemplateConfig';
import * as TreeView from 'react-treeview';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { Button, Form, Modal } from 'semantic-ui-react';
import OAuthClient from '../../../api';
const FontAwesome = require('react-fontawesome');
const _ = require('lodash');
class State {
    collapsedBookkeeping: any;
    data: any;
    currentIndex: number;
    parentIndex: number;
    selectedTemplateName: string;
    openDelModal: boolean;
    delTemplate: any;
    VODLicensePresent: boolean;
    VODOnlyLicensePresent: boolean;
    DAILicensePresent: boolean;
    allTemplates: any;
}

interface Props {

}

export default class AlarmTemplateView extends React.Component<Props, State> {

    componentWillMount() {
        // SAN-4530
        let vodOnly = false;
        if (!OAuthClient.storage) {
            // tslint:disable-next-line:no-console
            console.log('OAuth storage disabled');
            this.setState({
              VODLicensePresent: false,
              VODOnlyLicensePresent: false,
              DAILicensePresent: false
            });
        } else {
            // retrieve the oauth information as a string from session storage
            let dataStr = OAuthClient.storage.getItem('oauth');
            let data = dataStr && JSON.parse(dataStr);
            if (data && data.key) {
                // move the data to the state
                let { VODLicensePresent, VODOnlyLicensePresent, DAILicensePresent} = data;
                this.setState({
                  VODLicensePresent: VODLicensePresent,
                  VODOnlyLicensePresent: VODOnlyLicensePresent,
                  DAILicensePresent: DAILicensePresent
                });
                vodOnly = VODOnlyLicensePresent;
            }
        }
        this.setState({
            collapsedBookkeeping: [false, false, false],
            data: [],
            allTemplates: [],
            selectedTemplateName: 'streamDefault',
            openDelModal: false
        });
        if (vodOnly) {
            this.getTemplates('firstLoad', 'vod', 'streamDefault', vodOnly);
        } else {
            this.getTemplates('firstLoad', 'all segments', 'streamDefault', vodOnly);
        }
        this.handleClick = this.handleClick.bind(this);
        this.deleteTemplate = this.deleteTemplate.bind(this);
        this.handleDelModalClose = this.handleDelModalClose.bind(this);
    }

    getTemplates(operation: string, mode: string, templateName: string, vodOnly: boolean) {
        // tslint:disable-next-line:variable-name
        let __this = this;
        let parentIndex = 0;
        let currentIndex = 1;
        let selectedOption = '';
        let allSegmentsStreams: any = ['Add New Template'], sampleStreams: any = ['Add New Template'],
            headerStreams: any = ['Add New Template'],  vodStreams: any = ['Add New Template'], allTemplates: any = [], daiStreams: any = ['Add New Template'];
        let data: { type: string; options: any; }[] | { type: string; options: any; }[];

        if (vodOnly) {
            data = [
                {
                    type: 'VOD',
                    options: vodStreams
                }
            ];
        } else {
            data = [
                {
                    type: 'All Segments',
                    options: allSegmentsStreams,
                }, {
                    type: 'Sample',
                    options: sampleStreams,
                }, {
                    type: 'Header Only',
                    options: headerStreams
                }, {
                    type: 'VOD',
                    options: vodStreams
                }, {
                    type: 'Dynamic Ad',
                    options: daiStreams
                }
            ];
        }

        let url = 'http://default/api/config/templates/adp?summary=true';
        axios.get(url, {headers: {'x-orderby': 'order templates by name'}})
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined && response.data.templates !== undefined) {
                    _.map(response.data.templates, (template: any) => {
                        allTemplates.push(template.name);
                        if (template.mode === 'all segments' || template.mode === 'any') {
                            allSegmentsStreams.push(template.name);
                        } else if (template.mode === 'sample') {
                            sampleStreams.push(template.name);
                        } else if (template.mode === 'header only') {
                            headerStreams.push(template.name);
                        } else if (template.mode === 'vod') {
                            vodStreams.push(template.name);
                        } else if (template.mode === 'dynamic ad') {
                            daiStreams.push(template.name);
                        }
                    });

                    if (operation === 'firstLoad') {
                        parentIndex = 0;
                    } else {
                        parentIndex = __this.state.parentIndex ? __this.state.parentIndex : 0;
                    }

                    if (mode === 'all segments' || mode === 'any') {
                        currentIndex = templateName ? allSegmentsStreams.indexOf(templateName) : 1;
                        selectedOption = 'All Segments';
                    } else if (mode === 'sample') {
                        currentIndex = templateName ? sampleStreams.indexOf(templateName) : 1;
                        selectedOption = 'Sample';
                    } else if (mode === 'header only') {
                        currentIndex = templateName ? headerStreams.indexOf(templateName) : 1;
                        selectedOption = 'Header Only';
                    } else if (mode === 'vod') {
                        currentIndex = templateName ? vodStreams.indexOf(templateName) : 1;
                        selectedOption = 'VOD';
                    } else if (mode === 'dynamic ad') {
                        currentIndex = templateName ? daiStreams.indexOf(templateName) : 1;
                        selectedOption = 'Dynamic Ad';
                    }

                    __this.setState({
                        data: data,
                        allTemplates: allTemplates
                    },              () =>  __this.selectTemplate(templateName, operation, parentIndex, currentIndex, selectedOption, data));
                }
            }).catch(function (error: AxiosRequestConfig) {
            // tslint:disable-next-line:no-console
            console.log('fetchData() error: ', error);
        });

    }

    renderRightPanel(selectedOption: string) {
        switch (selectedOption) {
            case 'All Segments':
                // tslint:disable-next-line:max-line-length
                return <AlarmTemplateConfig mode="All Segments" templateName={this.state.selectedTemplateName} refresh={(op: string, mode: string, templateName: string) => this.getTemplates(op, mode, templateName, this.state.VODOnlyLicensePresent)} allTemplates={this.state.allTemplates} />;
            case 'Sample':
                // tslint:disable-next-line:max-line-length
                return <AlarmTemplateConfig mode="Sample" templateName={this.state.selectedTemplateName} refresh={(op: string, mode: string, templateName: string) => this.getTemplates(op, mode, templateName, this.state.VODOnlyLicensePresent)} allTemplates={this.state.allTemplates} />;
            case 'Header Only':
                // tslint:disable-next-line:max-line-length
                return <AlarmTemplateConfig mode="Header Only" templateName={this.state.selectedTemplateName} refresh={(op: string, mode: string, templateName: string) => this.getTemplates(op, mode, templateName, this.state.VODOnlyLicensePresent)} allTemplates={this.state.allTemplates} />;
            case 'VOD':
                // tslint:disable-next-line:max-line-length
                return <AlarmTemplateConfig mode="VOD" templateName={this.state.selectedTemplateName} refresh={(op: string, mode: string, templateName: string) => this.getTemplates(op, mode, templateName, this.state.VODOnlyLicensePresent)} allTemplates={this.state.allTemplates} />;
            case 'Dynamic Ad':
                // tslint:disable-next-line:max-line-length
                return <AlarmTemplateConfig mode="Dynamic Ad" templateName={this.state.selectedTemplateName} refresh={(op: string, mode: string, templateName: string) => this.getTemplates(op, mode, templateName, this.state.VODOnlyLicensePresent)} allTemplates={this.state.allTemplates} />;
            default:
                // tslint:disable-next-line:max-line-length
                return <AlarmTemplateConfig mode="All Segments" templateName={this.state.selectedTemplateName} refresh={(op: string, mode: string, templateName: string) => this.getTemplates(op, mode, templateName, this.state.VODOnlyLicensePresent)} allTemplates={this.state.allTemplates} />;
        }
    }

    handleClick(parentIndex: number) {
        let [...collapsedBookkeeping] = this.state.collapsedBookkeeping;
        collapsedBookkeeping[parentIndex] = !collapsedBookkeeping[parentIndex];
        if (parentIndex === 2 ) {
            this.setState({collapsedBookkeeping: collapsedBookkeeping, parentIndex: parentIndex});
        }
        this.setState({collapsedBookkeeping: collapsedBookkeeping});
    }

    handleOptionsClick(parentIndex: number, index: number, entry: string) {
        this.setState({
            currentIndex: index,
            parentIndex: parentIndex,
            selectedTemplateName: entry
        });
    }

    render() {

        const inlineStyle = {
            modal : {
                marginTop: '20px !important',
                marginLeft: 'auto',
                marginRight: 'auto'
            }
        };
        let selectedOption = '';
        if (this.state.VODOnlyLicensePresent) {
            selectedOption = 'VOD';
        } else {
            selectedOption = (this.state.data !== undefined && this.state.parentIndex !== undefined)
                ? this.state.data[this.state.parentIndex].type
                : null;
        }
        const collapsedBookkeeping = this.state.collapsedBookkeeping;

        return (
            <React.Fragment>
                <div className="view-content" id="systemConfig">
                    <div className="pageTitle">
                        <div className="page-title-block">
                            <div className="iq-temp-key-val">
                                <div className="iq-temp-val page-title-text">Alarm Template</div>
                            </div>
                        </div>
                    </div>
                    <div className="view-clientarea">
                        <div className="divided-area-main">
                            <div className="sysConfig-left-panel vh-hack-full">
                                {this.state.data.map((node: any, i: number) => {
                                    if (((!this.state.VODLicensePresent && !this.state.VODOnlyLicensePresent) && node.type === 'VOD') || ((!this.state.DAILicensePresent) && node.type === 'Dynamic Ad')) {
                                        return null;
                                    } else {
                                        const label =
                                            <span className="node" onClick={() => this.handleClick(i)}>
                                                {node.type}
                                            </span>;
                                        return (
                                            <TreeView
                                                key={i}
                                                nodeLabel={label}
                                                collapsed={collapsedBookkeeping[i]}
                                                onClick={() => this.handleClick(i)}
                                            >
                                                {node.options.map((entry: any, index: number) => {
                                                    return (
                                                        <div
                                                            className={`asset-card card${(this.state.currentIndex === index && this.state.parentIndex === i) ? ' selected' : ''}`}
                                                            key={entry}
                                                            onClick={() => this.handleOptionsClick(i, index, entry)}
                                                        >
                                                            {this.renderCardContent(entry)}
                                                        </div>
                                                    );
                                                })}
                                            </TreeView>
                                        );
                                    }
                                })}
                            </div>
                            <div className="view-content config-view flow sysConfig-right-panel vertical-flex-parent" id="asset-alias">
                                {this.renderRightPanel(selectedOption)}
                                <Modal
                                    open={this.state.openDelModal}
                                    onClose={this.handleDelModalClose}
                                    size="small"
                                    style={inlineStyle.modal}
                                >
                                    <Modal.Header>Delete</Modal.Header>
                                    <Modal.Content>
                                        <Form>
                                            <Form.Field>
                                                Template will be deleted from the system. Do you want to continue?
                                            </Form.Field>
                                        </Form>
                                    </Modal.Content>
                                    <Modal.Actions>
                                        <Button
                                            className="filterPanel-secondary-btn modal-button-padding"
                                            onClick={() => this.deleteTemplate(selectedOption)}
                                        >
                                            Yes
                                        </Button>
                                        <Button className="filterPanel-primary-btn modal-button-padding" onClick={this.handleDelModalClose}>
                                            No
                                        </Button>
                                    </Modal.Actions>
                                </Modal>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }

    handleDelModalClose() {
        this.setState({
            openDelModal: false
        });
    }
    renderCardContent(entry: string) {
        return (entry === 'Add New Template')
            ? (
                <div>
                    <FontAwesome name="fas fa-plus" />
                    <i>{entry}</i>
                </div>
            )
            : (entry === 'streamDefault')
                ? (
                    <div>
                        {entry}
                    </div>
                )
                : (
                    <div className="card-content">
                        <i
                            className="card-action-icon no-caption fa fa-trash"
                            onClick={() =>  this.setState({openDelModal: true, delTemplate: entry})}
                            title="Delete Template"
                        />
                        {entry}
                    </div>
                );

    }

    deleteTemplate(selectedOption: string) {
        let mode = '';
        // tslint:disable-next-line:variable-name
        let __this = this;
        this.handleDelModalClose();
        switch (selectedOption) {
            case 'All Segments':
                mode = 'all segments';
                break;
            case 'Sample':
                mode = 'sample';
                break;
            case 'Header Only':
                mode = 'header only';
                break;
            case 'VOD':
                mode = 'vod';
                break;
            case 'Dynamic Ad':
                mode = 'dynamic ad';
                break;
            default:
                mode = 'all segments';
                break;
        }
        let type = mode.toLowerCase().replace(/ /g, '');
        let url = 'http://default/api/config/templates/adp/' + type + '/' + encodeURIComponent(this.state.delTemplate);
        axios.delete(url)
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined && response.data.code === 'SUCCESS') {
                    __this.getTemplates('delete', mode, 'streamDefault', __this.state.VODOnlyLicensePresent);
                } else {
                    // tslint:disable-next-line:no-console
                    console.log('edit user error, got ', response.data);
                }
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('edit user error, got: ', error);
            });
    }

    selectTemplate(templateName: string, operation: string, parentIndex: number, currentIndex: number, selectedOption: string, data: any) {
        let  selectedTemplateName = templateName;
        if (operation === 'firstLoad') {
            parentIndex = 0; // currentIndex = 1;
        } else {
            if (selectedOption === 'All Segments') {
                currentIndex = data[0].options.indexOf(selectedTemplateName);
            } else if (selectedOption === 'Sample') {
                currentIndex = data[1].options.indexOf(selectedTemplateName);
            } else if (selectedOption === 'Header Only') {
                currentIndex = data[2].options.indexOf(selectedTemplateName);
            } else if (selectedOption === 'VOD') {
                if (this.state.VODOnlyLicensePresent) {
                    currentIndex = data[0].options.indexOf(selectedTemplateName);
                } else {
                    currentIndex = data[3].options.indexOf(selectedTemplateName);
                }
            }
        }

        this.setState({
           parentIndex:  parentIndex,
            currentIndex: currentIndex,
            selectedTemplateName: selectedTemplateName
        },            () => this.renderRightPanel(selectedOption));
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/config/alarmTemplate/alarmTemplates.tsx